import { createAxiosClient } from "@ntg/component-library/utilities";
import type { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

export interface IProductD365 {
    productNumber: string;
    productSearchName: string;
    productName: string;
    productDescription: string;
    storageDimensionGroupName: string;
    trackingDimensionGroupName: string;
    harmonizedSystemCode: string;
    productType: string;
}

export const getProductD365 = async (
    payload: IReadVerbPayload,
): Promise<IProductD365> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IProductD365>(
        `/Product/GetProductD365`,
        payload,
    );
    return response.data;
};
